import { _ as r } from "../internals/export.js";
import { a as o } from "../internals/array-from.js";
import { c as t } from "../internals/check-correctness-of-iteration.js";
r({
  target: "Array",
  stat: !0,
  forced: !t(function (r) {
    Array.from(r);
  })
}, {
  from: o
});